<div id="email-directory" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Email Directory</h2>
    <p class="inner-lead mt-3">
      You can reach out to the various departments and administrative offices of Shah Satnam Ji Girls' College through
      the following email addresses.
    </p>

    <div class="table-responsive-inner mt-4">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Office / Department</th>
            <th>Email Address</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>General Enquiry</td>
            <td><a href="mailto:ssgians1@gmail.com">ssgians1@gmail.com</a></td>
          </tr>
          <tr>
            <td>Administrative Office</td>
            <td><a href="mailto:ssji1525@gmail.com">ssji1525@gmail.com</a></td>
          </tr>
          <tr>
            <td>Admissions Desk</td>
            <td><a href="mailto:ssgians1@gmail.com">ssgians1@gmail.com</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>